/* PLAYERS – badges taille / vendu sur les vignettes produit */
(function () {
  var SIZE_RE = /\s[-–]\s([^-–]+)$/;

  function enhanceCard(card) {
    if (card.dataset.plDone) return;
    card.dataset.plDone = '1';

    var link = card.querySelector('.card__heading a, .card__heading');
    var badgeWrap = card.querySelector('.card__badge');
    if (!link || !badgeWrap) return;

    badgeWrap.querySelectorAll('.badge').forEach(function (b) {
      var t = (b.textContent || '').trim().toLowerCase();
      if (t === 'épuisé' || t === 'epuisé' || t === 'sold out') {
        b.textContent = 'Vendu';
        b.classList.add('pl-sold');
        card.classList.add('pl-is-sold');
      }
    });

    var text = (link.textContent || '').trim();
    var m = text.match(SIZE_RE);
    if (m) {
      var size = m[1].trim();
      var badge = document.createElement('span');
      badge.className = 'badge pl-size-badge';
      badge.textContent = size;
      badge.setAttribute('aria-label', 'Taille ' + size);
      badgeWrap.prepend(badge);
      card.querySelectorAll('.card__heading a').forEach(function (a) {
        a.childNodes.forEach(function (n) {
          if (n.nodeType === 3 && SIZE_RE.test(n.textContent.trim())) {
            n.textContent = n.textContent.trim().replace(SIZE_RE, '');
          }
        });
      });
    }
  }

  function run(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(enhanceCard);
    document.querySelectorAll('.product-form__submit[disabled] span').forEach(function (s) {
      if (/épuisé|sold out/i.test(s.textContent)) s.textContent = 'Vendu';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    run();
    var obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) run(n); });
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });
  });
})();
